// apps/admin-surgia/src/store/auth.ts
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { UserPermission } from '../../../../packages/contract/dtos';

// Initial state matching hub pattern
const adminInitialState = {
  isLoading: false,
  globalState: {
    first_name: null as string | null,
    last_name: null as string | null,
    full_name: null as string | null,
    email: null as string | null,
    subject_id: null as string | null,
    creation_date: null as string | null,
    user_permissions: [] as UserPermission[],
    user_branches: null as string | null,
    // Token data
    access_token: null as string | null,
    id_token: null as string | null,
    refresh_token: null as string | null,
    expires_at: null as number | null,
  },
};

const authSlice = createSlice({
  name: 'auth',
  initialState: adminInitialState,
  reducers: {
    setGlobalState: (state, action: PayloadAction<{
      first_name: string;
      last_name: string;
      full_name: string;
      email: string;
      subject_id: string;
      creation_date: string | null;
      user_permissions: UserPermission[];
      user_branches: string;
      // Token data
      access_token: string;
      id_token: string;
      refresh_token: string;
      expires_at: number;
    }>) => {
      state.globalState = action.payload;
    },
    
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
    
    logout: () => {
      return adminInitialState;
    },
  },
});

export const { setGlobalState, setLoading, logout } = authSlice.actions;
export default authSlice.reducer;